import React, { useEffect, useRef, useState } from 'react';

export default function DashboardAccordion({ id, title, summary, open, onToggle, children, preview, toggleLabel }) {
  const [visited, setVisited] = useState(open);
  const trigger = useRef(null);
  const heading = useRef(null);
  useEffect(() => {
    if (!open) return;
    setVisited(true);
    const frame = requestAnimationFrame(() => {
      const anchor = heading.current || trigger.current;
      const rect = anchor?.getBoundingClientRect();
      if (rect && (rect.top < 12 || rect.top > window.innerHeight - 72)) {
        anchor.scrollIntoView?.({ block: 'start', behavior: window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
    });
    return () => cancelAnimationFrame(frame);
  }, [open]);
  return <section className={`student360-panel${preview ? ' student360-growth' : ''}`}>
    {preview && <div className="student360-panel-preview"><h2 ref={heading} id={`${id}-title`} className="student360-card-title">{title}</h2>{preview}</div>}
    <button ref={trigger} id={`${id}-trigger`} className={`student360-panel-trigger${preview ? ' student360-growth-trigger' : ''}`} type="button" aria-expanded={open} aria-controls={`${id}-content`} onClick={onToggle}>
      <span><strong>{toggleLabel || title}</strong>{!preview && summary && <small>{summary}</small>}</span><span className="student360-panel-chevron" aria-hidden="true">{open ? '−' : '+'}</span>
    </button>
    <div id={`${id}-content`} role="region" aria-labelledby={`${id}-${preview ? 'title' : 'trigger'}`} hidden={!open} className="student360-panel-content">{(open || visited) && children}</div>
  </section>;
}
